import { writable } from "react-svelte-stores";
import { CuratedListsResponse } from "../types/listenApi";
import { Moment } from "../types/moments";

export const curatedListsStore = writable<CuratedListsResponse | null>(null);

export const popularMomentsStore = writable<Moment[] | null>(null);
